module.exports = __webpack_public_path__ + "static/media/wellbeing manager.bc05b47f.svg";